import classnames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import '../style/accountnav.css';

const navRoutes = ['users', 'channels', 'players', 'integrations'];

export default function AccountNav() {
  const { pathname } = useLocation();

  return (
    <div className="account-nav-container">
      <ul className="account-subnav">
        {navRoutes.map((route) => (
          <li key={route} className={classnames('account-subnav-item', { active: pathname.includes(route) })}>
            <Link to={`/${route}`}>{route}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
